import type { TabsItem } from '@nuxt/ui'

export const TRAINER_TABS: TabsItem[] = [
  { value: 'index', label: 'О тренере' },
  { value: 'directions', label: 'Направления' },
  { value: 'schedule', label: 'Расписание' },
  { value: 'schools', label: 'Школы' },
  { value: 'our-pride', label: 'Наша гордость' },
  { value: 'news', label: 'Новости' },
  // { value: 'competitions', label: 'Соревнования' },
  { value: 'reviews', label: 'Отзывы' },
  { value: 'contacts', label: 'Контакты' },
]

export const MOCK_TRAINER_DESCRIPTION =
  '<p>Футбольный тренер — это важная фигура в жизни молодых спортсменов. Он не только обучает технике игры, но и вдохновляет детей на достижение новых высот. Отличный тренер понимает, как развивать индивидуальные способности каждого игрока, создавая комфортную и поддерживающую атмосферу. Его задача — не просто подготовить чемпионов, но и привить любовь к спорту, научить работать в команде и преодолевать трудности.</p>'
